import { ToastMessageVariants, validationTypes } from '../../../../../../../util/uiconstants';
import { labels } from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import { setFormV2ToasterVisibility } from '../../../../../../../actions/toastactions';
import { useDispatch, useSelector } from 'react-redux';
import { useUserPreferences } from '../../../../../../../util/customHooks';
import { getValidationsForDocumentId } from '../../../../../../../selectors/Forms/canvasFormSelectors';

export default function MultiEntityIndividualProfileBanner(props) {
	const userPreferences = useUserPreferences(),
		validations = useSelector((store) => getValidationsForDocumentId(store, props.document.id)),
		dispatch = useDispatch();

	if (!userPreferences.permissions.canUpdateEngagementContent) {
		dispatch(
			setFormV2ToasterVisibility(
				true,
				ToastMessageVariants.Error,
				Utility.createRichTextElement(labels.multiEntityIndividualProfileBannerMessage)
			)
		);
	}

	if (validations && validations.length > 0 && validations.some((t) => t.validationTypeId === validationTypes.ChangeNotSubmittedMultiEntityIndividualDocument)) {
		dispatch(
			setFormV2ToasterVisibility(
				true,
				ToastMessageVariants.Warning,
				Utility.createRichTextElement(labels.STEntityProfileBannerMessage)
			)
		);
	}
}
